import { Button, CircularProgress } from "@mui/material";
import React from "react";
import MuiTypography from "../MuiTypography";

const SubmitLoaderButton = ({
  variant = "contained",
  isDisable = "false",
  isLoading = "false",
  btnText = "Add",
  sx,
  ...rest
}) => {
  return (
    <Button
      variant={variant}
      disabled={isDisable}
      sx={{
        width: "fit-content",
        minWidth: "75px",
        ...sx,
      }}
      {...rest}
    >
      {isLoading ? (
        <CircularProgress size="22px" sx={{ color: "background.white" }} />
      ) : (
        <MuiTypography
          variant="14"
          component={"span"}
          textAlign={"center"}
          fontWeight={"500"}
        >
          {btnText}
          {/* Save */}
        </MuiTypography>
      )}
    </Button>
  );
};

export default SubmitLoaderButton;
